import React from 'react';
import './input.css';
import { Tooltip, useDisclosure } from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';
import { REGEX_PASSWORD } from '../../util/util';

const CustomInput = ({
  label,
  type,
  name,
  value,
  onChange,
  onBlur,
  error,
  allowedFileTypes,
  max,
  min,
  disabled,
}) => {
  const inputStyle = {
    borderColor: error ? '#F56565' : '', // error color
    backgroundColor: disabled ? '#E2E8F0' : '', // disabled color
  };

  const { isOpen, onOpen, onToggle, onClose } = useDisclosure();

  const handlePasswordInput = (e) => {
    // only allow letters, numbers, and specific special characters
    const validPattern = /^[a-zA-Z0-9!@#$%^&*()_+-]*$/;
    if (
      type === 'password'
    ) {
      onChange(e);
    } else if (type !== 'password') {
      onChange(e);
    }
  };

  return (
    <div className="container-input">
      <label className="py-1">
        <b>{label}</b>
        {type === 'file' ? (
          <input
            className="form-control custom-input"
            type={type}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            required
            style={inputStyle}
            accept={allowedFileTypes.join(',')}
            autoComplete='off'
          />
        ) : (
          <input
            className="form-control custom-input"
            type={type}
            name={name}
            value={value}
            onChange={handlePasswordInput}
            onBlur={onBlur}
            required
            style={inputStyle}
            max={max}
            min={min}
            maxLength={type === 'password' ? 14 : undefined}
            disabled={disabled}
            pattern={
              type === 'password' ? REGEX_PASSWORD : undefined
            }
            autoComplete='off'
          />
        )}
      </label>
      {error && (
        <Tooltip
          label={error}
          aria-label="A tooltip"
          isOpen={isOpen}
          fontSize="16px"
        >
          <div
            className="d-flex flex-row align-items-center"
            onMouseEnter={onOpen}
            onMouseLeave={onClose}
            onClick={onToggle}
          >
            <span className="single-line">
              <InfoIcon /> {error}
            </span>
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default CustomInput;
